import React, { useState } from 'react';
import { InputAdornment, TextField as MuiTextField } from '@mui/material';
import { useTheme } from 'styled-components';
import { getTextFieldSx } from './textfield';
import { TextFieldProps } from './textfield.type';
import { IconButton } from '../../icon/button/icon-button';
import { IconHidePassword } from '../../icons/hide-password';
import { IconShowPassword } from '../../icons/show-password';

export const PasswordField = (props: TextFieldProps) => {
    const { suffix, appearance, fieldScale, ...rest } = props;
    const [showPassword, setShowPassword] = useState(false);
    const theme = useTheme();

    return (
        <MuiTextField
            type={showPassword ? 'text' : 'password'}
            {...rest}
            data-web-textfield={appearance === 'web' || undefined}
            size={props.size as 'small' | 'medium' | undefined}
            className="w-full"
            sx={getTextFieldSx(theme, {
                size: props.size,
                radius: props.radius,
                width: props.width,
                appearance,
                fieldScale,
            })}
            InputProps={{
                endAdornment: (
                    <InputAdornment
                        position="end"
                        style={suffix ? { width: 'auto', minWidth: 'max-content', flexShrink: 0 } : undefined}
                    >
                        {suffix}
                        <IconButton
                            disabled={props.disabled}
                            icon={showPassword ? <IconHidePassword /> : <IconShowPassword />}
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword((show) => !show)}
                        />
                    </InputAdornment>
                ),
            }}
        />
    );
};
